import type { ICartItemDetail } from '@/common/interfaces/cart.interface';
import { checkIfMTO } from '@/utilities/PricingUtils';

export const resolveStoreCheckoutCartItemIsMto = (item: ICartItemDetail): boolean => {
  if (item.isMadeToOrder) {
    return true;
  }

  if (item.decorMethodInfo?.length) {
    return checkIfMTO(item.decorMethodInfo);
  }

  return false;
};

export const resolveStoreCheckoutHasMtoItems = (
  cartItems: ICartItemDetail[],
  isStoreMadeToOrder = false
): boolean => {
  if (isStoreMadeToOrder) {
    return true;
  }

  return cartItems.some(resolveStoreCheckoutCartItemIsMto);
};
